import { authorizedRequest } from "../httprequests";
import { TenantLocation } from "../types/locations";

export async function getLocation(locationId: number | string) {
  return authorizedRequest.get<TenantLocation>(`/locations/${locationId}`);
}
